export default {"src":"/_next/static/media/blogs-icon.e377cee2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};